var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartPlus1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 513,
    viewBox: "0 0 513 513",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M235.256 192.851H277.922V128.851H341.922V86.1842H277.922V22.1842H235.256V86.1842H171.256V128.851H235.256M149.922 384.851C126.456 384.851 107.256 404.051 107.256 427.518C107.256 450.984 126.456 470.184 149.922 470.184C173.389 470.184 192.589 450.984 192.589 427.518C192.589 404.051 173.389 384.851 149.922 384.851ZM363.256 384.851C339.789 384.851 320.589 404.051 320.589 427.518C320.589 450.984 339.789 470.184 363.256 470.184C386.722 470.184 405.922 450.984 405.922 427.518C405.922 404.051 386.722 384.851 363.256 384.851ZM154.189 316.584V314.451L173.389 278.184H331.256C346.189 278.184 361.122 269.651 367.522 256.851L450.722 107.518L414.456 86.1842L331.256 235.518H181.922L92.3224 43.5175H21.9224V86.1842H64.589L141.389 248.318L111.522 299.518C109.389 305.918 107.256 312.318 107.256 320.851C107.256 344.318 126.456 363.518 149.922 363.518H405.922V320.851H158.456C156.322 320.851 154.189 318.718 154.189 316.584Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartPlus1);
export default __webpack_public_path__ + "static/media/cart-plus 1.08fe5cb87478ae9c2b46118b55f187d8.svg";
export { ForwardRef as ReactComponent };